import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperationOverlayLargeNg4Service } from './operation-overlay-large.service';
import { OperationOverlayLargeDialogComponent } from './operation-overlay-large-dialog/operation-overlay-large-dialog.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule],
    declarations: [OperationOverlayLargeDialogComponent],
    providers: [OperationOverlayLargeNg4Service],
})
export class OperationOverlayLargeModule {}
